// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"RecentReadingSessionsListSkeleton_skeletonContainer__zT_uq","skeletonItem":"RecentReadingSessionsListSkeleton_skeletonItem__Dj1NI"};